import styles from '../styles.module.css';
import ChartIcon from '@/assets/icons/chart.svg?react';
import {
  AdminCardHeader,
  AdminTableBody
} from '@/components/AdminToolComponents/card';
import DataPoint from '@/components/LocationDetails/dataPoint';
import { LocationFormData } from '@/hooks/services/Locations';

export type OnDataPointChange = (dataPoint: string, value: boolean) => void;

interface DataPointTableProps {
  formData: LocationFormData;
  onDataPointChange: OnDataPointChange;
  dataPointsLabels?: Record<string, string>;
  editMode: boolean;
}

export const DataPointTable = ({
  formData,
  onDataPointChange,
  dataPointsLabels,
  editMode
}: DataPointTableProps) => (
  <div className={styles.adminContainer}>
    <AdminCardHeader
      left={
        <>
          <ChartIcon className={styles.adminIconHeader} />
          <h2 className={styles.adminTitle}>User Data Point Visibility</h2>
        </>
      }
    />
    <AdminTableBody>
      <DataPoint
        editMode={editMode}
        formData={formData}
        handleDataPointChange={onDataPointChange}
        dataPointsLabels={dataPointsLabels}
      />
    </AdminTableBody>
  </div>
);
